export default {
  path: '*',

  /* 布局基页 */
  getComponent(nextState, cb) {
    require.ensure(
      [],
      (require) => {
        cb(null, require('VIEW/404').default);
      },
      '404View',
    );
  },
};



// WEBPACK FOOTER //
// ./src/route/404Redux.js